import React from 'react';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

export interface IMessageRequire {
  message?: string | null | JSX.Element;
  classWrapper?: string;
  isWarning?: boolean;
  labelClass?: string;
  classMessage?: string;
}
export default function ECMessageError({
  message,
  classWrapper = 'ms-2',
  isWarning,
  labelClass = 'mt-1',
  classMessage = '',
}: IMessageRequire): JSX.Element {
  if (message) {
    return (
      <div className={classWrapper}>
        <small
          className={`text-cherry d-flex align-items-center ${isWarning && 'text-dark-red'} ${
            labelClass ?? ''
          }`}
        >
          <ExclamationTriangleFill />
          <span className={`d-block px-1 ${classMessage}`}>{message}</span>
        </small>
      </div>
    );
  }
  return <></>;
}
